const InfoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      data-testid="info-icon"
    >
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#9C28B1"
      />
      <path
        d="M9.56055 10.1205C10.0905 9.34048 10.9005 8.57031 11.8505 8.94031C12.0887 9.03397 12.2972 9.19026 12.4539 9.3927C12.6105 9.59514 12.7096 9.83634 12.7405 10.0905C12.79 10.4919 12.7312 10.8992 12.5704 11.2704C12.2704 12.0604 11.9504 12.8405 11.5704 13.6005C11.1585 14.4294 10.8624 15.3108 10.6904 16.2203C10.5141 16.8725 10.5966 17.5674 10.9205 18.1603C11.1199 18.4246 11.3902 18.6269 11.7 18.7438C12.0097 18.8606 12.3463 18.8872 12.6705 18.8204C13.4287 18.6597 14.0953 18.2117 14.5305 17.5704"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0596 6.84961C12.888 6.84961 13.5596 6.17804 13.5596 5.34961C13.5596 4.52118 12.888 3.84961 12.0596 3.84961C11.2311 3.84961 10.5596 4.52118 10.5596 5.34961C10.5596 6.17804 11.2311 6.84961 12.0596 6.84961Z"
        fill="white"
      />
    </svg>
  );
};

export default InfoIcon;
